import { visitOne, visitTwo, wxSdkInfo } from '../../api/api';
import axios from 'axios';
import { Toast } from 'vant';
import qs from 'qs';
// 获取url地址查询参数
function getQueryString(name: string) {
  const queryString = window.location.search.substr(1);
  const queryArray = queryString.split('&');
  let result = null;
  queryArray.forEach((i) => {
    const itemArray = i.split('=');
    if (itemArray[0] === name) {
      result = decodeURIComponent(itemArray[1]);
    }
  });
  return result;
}

// 在app里弹出登陆
export const inAppAlertLogin = () => {
  if (!window.udid) {
    return;
  }
  if (parseFloat(window.version) >= 4.5) {
    window.handleMessage('{"action":"mUserLogin","data":""}');
  } else {
    window.location.href = 'client:logout';
  }
};

// 判断是否是微信浏览器
function isWeiXin() {
  const reg = /MicroMessenger/g;
  const ua = window.navigator.userAgent;
  return reg.test(ua);
}
// 判断是不是手机
function isMobile() {
  const userAgentInfo = navigator.userAgent;
  const Agents: string[] = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ];
  let flag = false;
  for (const v of Agents) {
    if (userAgentInfo.indexOf(v) > -1) {
      flag = true;
      break;
    }
  }
  return flag;
}
// 是否自动打开
function autoOpenApp() {
  if (!isWeiXin() && !window.udid) {
    window.location.href =
      'shangyounews://{"dt":"7","url":"' + location.href + '"}';
  } else {
    return;
  }
}

// 数组分类
const groupBy = (key: string) => (array: any[]) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

// 新版app分享
export interface ShareOption {
  title: string;
  url: string;
  subtitle?: string;
  classId: number | string; // -1
  id: number | string; // -1
  image?: string;
  type: any; // 3 | 6 | 11 | 12 | 13 | 16
}

const appShare = (data: ShareOption) => {
  setTimeout(() => {
    const option = {
      action: 'mSetShareInfo',
      data: JSON.stringify(data),
    };
    if (window.handleMessage) {
      window.handleMessage(JSON.stringify(option));
    }
  }, 500);
};
// 获取微信sdk
function wxConfig(statement: object) {
  window.wx.config({
    debug: false,
    ...statement,
    jsApiList: [
      // 所有要调用的 API 都要加到这个列表中
      'updateAppMessageShareData', // 分享到朋友
      'updateTimelineShareData', // 分享到朋友圈
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
    ],
  });
}
// 分享图片处理
function getCoverImage(post: any) {
  if (post.image) {
    return post.image;
  } else {
    return 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
  }
}
interface IWxShareOption {
  title: string;
  subtitle: string;
  link?: string;
  image?: string;
}
// 微信分享
function wxShareInfo(DetailsData: IWxShareOption) {
  wxSdkInfo({ jssdkurl: window.location.href }).then((res: any) => {
    const data = res.data;
    // console.log(DetailsData);
    const e = DetailsData;
    const messageData = {
      title: e.title, // 分享标题
      desc: e.subtitle, // 分享描述
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: getCoverImage(e), // 分享图标
    };
    wxConfig(data);
    window.wx.ready(() => {
      window.wx.updateAppMessageShareData({
        ...messageData,
      });
      window.wx.updateTimelineShareData({
        ...messageData,
      });
    });
  });
}
// 添加pv
function addPv(e: number | string) {
  if (process.env.NODE_ENV === 'production') {
    axios.get(
      `http://vote.cqcb.com/e/public/ViewClick/?classid=9&id=${e}&addclick=1`,
    );
    axios.get(
      `http://vote.cqcb.com/e/public/onclick/?enews=donews&classid=${e}&id=1`,
    );
  } else {
    console.log('添加pv成功');
  }
}
// 生成hash
const genHash = (len: number = 8) => {
  const allCapsAlpha = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
  const allLowerAlpha = [...'abcdefghijklmnopqrstuvwxyz'];
  // const allUniqueChars = [...`~!@#$%^&*()_+-=[]\{}|;:'",./<>?`];
  const allNumbers = [...'0123456789'];
  const base = [...allCapsAlpha, ...allNumbers, ...allLowerAlpha];
  return [...Array(len)]
    .map(() => base[Math.floor(Math.random() * base.length)])
    .join('');
};
// 判断字符串是否为JSON
function isJSON(str: string) {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === 'object' && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      // console.log('error：' + str + '!!!' + e);
      return false;
    }
  }
  console.log('It is not a string!');
}

// 配合vue-lazyload让富文本内图片支持懒加载
const replaceAllImg = (html: string) => {
  // vue-lazyload支持img标签pattern为
  // <img data-src="//domain.com/img1.jpg">
  const newContent = html.replace(/<img[^>]*>/gi, (str, capture) => {
    const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
    const url = str.match(srcReg);
    let mat: string = '';
    if (url) {
      mat = str.replace(/src/gi, `data-src`);
    }

    return mat;
  });

  return newContent;
};
const WechatLogin = () => {
  const { code, source } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  if (isWeiXin() && !code) {
    const appId = 'wx1949ed4a473b87ed';
    location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
      location.href,
    )}`;
  }
};
class Check {
  public cache: any[];
  public strategy: any = {
    must(val: string, msg: string) {
      if (val === '') {
        return msg;
      }
    },
    phone(val: string, msg: string) {
      if (
        !/^1[3-9]\d{9}$/.test(val) ||
        /^([69]\d{7})$/.test(val) ||
        /^([6]\d{5})$/.test(val) ||
        /^(09\d{8})$/.test(val)
      ) {
        return msg;
      }
    },
    IdCard(val: string, msg: string) {
      const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!p.test(val)) {
        return msg;
      }
    },
    email(val: string, msg: string) {
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val)) {
        return msg;
      }
    },
  };
  constructor() {
    this.cache = [];
  }
  fastCheck(list: any) {
    return new Promise((resolve, reject) => {
      list.map((item: any, index: number) => {
        if (this.strategy[item.type](item.data, item.msg)) {
          resolve({ code: 0, msg: item.msg });
        } else if (list.length === index + 1) {
          resolve({ code: 1, msg: '验证通过！' });
        }
      });
    });
  }
  add(list: any[]) {
    list.map((item: any) => {
      this.cache.push(() => {
        try {
          return this.strategy[item.type](item.data, item.msg);
        } catch (error) {
          throw new Error(`strategy don't have ${item.type} `);
        }
      });
    });
  }
  start() {
    const len = this.cache.length;
    if (len === 0) {
      throw new Error('当前没有验证方法');
    }
    for (let i = 0; i < len; i++) {
      const eroMsg = this.cache[i]();
      if (eroMsg) {
        console.log('jingru ', eroMsg);
        // return eroMsg;
        Toast.fail(eroMsg);
      }
    }
  }
  remove() {
    this.cache = [];
  }
}
export {
  getQueryString,
  isWeiXin,
  isMobile,
  autoOpenApp,
  groupBy,
  appShare,
  addPv,
  wxShareInfo,
  genHash,
  isJSON,
  replaceAllImg,
  WechatLogin,
  Check,
};
